export const seasonPoolExportFields = [
  {
    titleIntlKey: "seasonPools.columns.competition.title",
    fields: ["competitionId", "competitionExternalId", "competitionName"],
  },
  {
    titleIntlKey: "seasonPools.columns.season.title",
    fields: ["seasonId", "seasonExternalId", "seasonName"],
  },
  {
    titleIntlKey: "seasonPools.columns.pool.title",
    fields: [
      "nameLocal",
      "nameLatin",
      "abbreviationLocal",
      "abbreviationLatin",
      "externalId",
      "poolCode",
      "poolOrder",
      "stageCode",
      "stageExternalId",
      "stageName",
    ],
  },
];

export const defaultSeasonPoolExportFieldNames = ["nameLocal", "poolCode", "poolOrder", "stageCode", "stageName"];
